import { createAction } from 'redux-actions';

export const setMerchant = createAction('SET_MERCHANT');